import React, { HTMLAttributes, useContext } from "react";
import AppImg from "components/utils/AppImg";
import { AppContext } from "@vahak/core/dist/app-context";
import Skeleton from "react-loading-skeleton";

import Styles from "./LifeatVahakImage.module.scss";

interface LifeatVahak {
    id: number;
    widthLarge: number;
    widthSmall: number;
    imageurlLarge: string;
    title?: string;
}
interface Props extends HTMLAttributes<HTMLDivElement> {
    lifeatVahakImg: LifeatVahak;
}

const LifeatVahakImage = ({ lifeatVahakImg }: Props) => {
    const { isMobile } = useContext(AppContext);
    return (
        <div
            className={Styles.slideItem}
            style={{
                width: isMobile ? `${lifeatVahakImg.widthSmall}px` : `${lifeatVahakImg.widthLarge}px`,
                height: isMobile ? "200px" : "250px",
                margin: "6px"
            }}
        >
            {/* <Skeleton
                height={isMobile ? "200px" : "250px"}
                width={isMobile ? lifeatVahakImg.widthSmall : lifeatVahakImg.widthLarge}
            /> */}
            <AppImg
                src={`${lifeatVahakImg.imageurlLarge}`}
                alt={lifeatVahakImg.title}
                layout="responsive"
                width={isMobile ? `${lifeatVahakImg.widthSmall}` : `${lifeatVahakImg.widthLarge}`}
                height={isMobile ? "197" : "249"}
            />
        </div>
    );
};

export default LifeatVahakImage;
